import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// declare var $: any;
@Component({
  selector: 'app-ravi-navbar',
  templateUrl: './ravi-navbar.component.html',
  styleUrls: ['./ravi-navbar.component.scss']
})
export class RaviNavbarComponent implements OnInit {
  screenWidth: number;
  screenHeight: number;
  ypercentage = -60;

  constructor(private router: Router) { }

  ngOnInit(): void {

    this.onResize();
    if(this.screenWidth < 990) {
      this.ypercentage = -100;
    }

    this.animate();

    const showAnimimageleft = gsap.from('header > img', { 
      yPercent: -100,
      paused: true,
      duration: 0.8,
    }).progress(1);
    
    ScrollTrigger.create({
      start: "top top",
      end: 99999,
      onUpdate: (self) => {
        self.direction === -1 ? showAnimimageleft.play() : showAnimimageleft.reverse()
      }
    });

    const showAnimimagelogo = gsap.from('header > a > img', { 
      yPercent: -100,
      paused: true,
      duration: 0.8,
    }).progress(1);
    
    ScrollTrigger.create({
      start: "top top",
      end: 99999,
      onUpdate: (self) => {
        self.direction === -1 ? showAnimimagelogo.play() : showAnimimagelogo.reverse()
      }
    });

    $(document).ready(function(){
      $('.toggle div').click(function(){
        $('.menu').toggleClass('active');
        $('.toggle').toggleClass('active')
      })


      $('l1').click(function(){
        $('.menu').toggleClass('active');
        $('.toggle').toggleClass('active')
      })
    });
    
  }

  animate() {
    const showAnim = gsap.from('header', { 
      yPercent: this.ypercentage,
      paused: true,
      duration: 0.8,
      boxShadow: 'rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px'
    }).progress(1);
    
    ScrollTrigger.create({
      start: "top top",
      end: 99999,
      onUpdate: (self) => {
        self.direction === -1 ? showAnim.play() : showAnim.reverse()
      }
    });
  }

  navigate(rt) {
    console.log(rt);
    this.router.navigate([`/${rt}`]);
    document.getElementById('hamburger').click();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenWidth = window.innerWidth;
    this.screenHeight = window.innerHeight;
    if(this.screenWidth < 990) {
      this.ypercentage = -100;
    }
    this.animate();
  }
  

}
